@if($active()) {
  <button type="button" class="tp-btn" (click)="scrollToTop()" aria-label="To top screen">
    <app-icon [icon]="arrowIcon" class="font-20" style="transform: rotate(-90deg)"></app-icon>
  </button>
}
